export const FinTable = ({ columns, rows, note, testid, rightFrom = 1 }) => (
  <div
    data-testid={testid}
    className="overflow-x-auto rounded-sm border border-sand bg-white/85 shadow-[0_4px_24px_rgba(31,110,90,0.05)] backdrop-blur-sm"
  >
    <table className="w-full min-w-[420px] text-sm">
      {columns && (
        <thead>
          <tr className="bg-jade text-left">
            {columns.map((c, i) => (
              <th
                key={c}
                className={`px-4 py-3 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-ivory/90 ${
                  i >= rightFrom ? "text-right" : ""
                }`}
              >
                {c}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {rows.map((r, i) => {
          const row = Array.isArray(r) ? { cells: r } : r;
          const kind = row.kind;
          return (
            <tr
              key={i}
              className={`transition-colors duration-200 ${
                kind === "total"
                  ? "border-y border-gold/60 bg-gold/10 font-semibold text-graphite"
                  : kind === "sub"
                    ? "bg-jade/[0.06] font-medium text-jade"
                    : "border-b border-sand/60 text-graphite/80 hover:bg-sand/30"
              }`}
            >
              {row.cells.map((c, j) => (
                <td
                  key={j}
                  className={`px-4 py-3 ${
                    j >= rightFrom ? "whitespace-nowrap text-right font-medium" : ""
                  } ${kind === "total" && j === 0 ? "border-l-2 border-l-gold" : ""}`}
                >
                  {c}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
    {note && (
      <p className="border-t border-sand/70 px-4 py-3 text-xs italic text-graphite/50">{note}</p>
    )}
  </div>
);
